var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "info-page" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "8" } }, [
                _c("h1", [_vm._v("FAQs")]),
                _vm._v(" "),
                _c("div", { staticClass: "faq" }, [
                  _c(
                    "div",
                    { staticClass: "faq--questions" },
                    [
                      _c(
                        "Question",
                        {
                          attrs: {
                            title: "Wann fallen bei skilldoo Kosten an?"
                          }
                        },
                        [
                          _c("p", [
                            _vm._v(
                              "Du kannst kostenfrei unbeschränkt viele Jobprofile anlegen und dann die\n\t\t\t\t\t\t\t\tautomatisierte Suche und Auswahl der am besten geeigneten BewerberInnen nützen.\n\t\t\t\t\t\t\t\tSomit ist skilldoo leistungsorientierter als althergebrachte Jobbörsen. Erst wenn\n\t\t\t\t\t\t\t\tdirekter Kontakt zu passenden BewerberInnen aufgenommen wird, fallen Kosten an.\n\t\t\t\t\t\t\t\tGrundsätzlich gilt: der Preis bei skilldoo ist geringer als ein Inserat auf einer\n\t\t\t\t\t\t\t\tklassischen Jobbörse.\n\t\t\t\t\t\t\t"
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "Question",
                        {
                          attrs: {
                            title: "Welchen Vorteil bietet die Anonymität?"
                          }
                        },
                        [
                          _c("p", [
                            _vm._v(
                              "Wenn nicht bekannt werden soll, dass die gesuchte Position besetzt wird, bietet die\n\t\t\t\t\t\t\t\tAnonymität einen großen Vorteil. Es kann auch sein, dass man MitarbeiterInnen sucht,\n\t\t\t\t\t\t\t\taber dafür noch keine Freigabe vom Vorgesetzten hat.\n\t\t\t\t\t\t\t\tAber selbstverständlich wird dein/e künftige/r Mitarbeiter/in dich irgendwann näher\n\t\t\t\t\t\t\t\tkennenlernen wollen. Sobald das der Fall ist, liegt es an dir, ob du deine\n\t\t\t\t\t\t\t\tAnonymität aufhebst. Es gibt dabei keinen Zwang."
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "Question",
                        {
                          attrs: {
                            title:
                              "Wie erfolgt die Kontaktaufnahme mit BewerberInnen?"
                          }
                        },
                        [
                          _c("p", [
                            _vm._v(
                              "Die Kontaktaufnahme erfolgt über die integrierte Kontakt-Funktion. Sie bietet weiters\n\t\t\t\t\t\t\t\tdie einfache Möglichkeit, Termine zu vereinbaren und Zusagen oder Absagen zu\n\t\t\t\t\t\t\t\tversenden."
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "Question",
                        {
                          attrs: {
                            title: "Sind die Profile der BewerberInnen seriös?"
                          }
                        },
                        [
                          _c("p", [
                            _vm._v(
                              "Die angezeigten BewerberInnen sind aktiv bei skilldoo, es gibt keine Fake-Profile.\n\t\t\t\t\t\t\t\tDamit das gewährleistet ist, müssen sich BewerberInnen mit ihrer Mobiltelefon-Nummer\n\t\t\t\t\t\t\t\tregistrieren und regelmäßig bestätigen, ob sie aktiv einen Job suchen."
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "Question",
                        {
                          attrs: {
                            title:
                              "Muss ich bei skilldoo eine Anzeige schalten?"
                          }
                        },
                        [
                          _c("p", [
                            _vm._v(
                              "Nein, das ist ein weiterer Vorteil von skilldoo. ArbeitgeberInnen müssen sich nicht\n\t\t\t\t\t\t\t\tmehr lange überlegen, wie sie eine Anzeige gestalten oder textieren. Mit dem\n\t\t\t\t\t\t\t\teinfachen "
                            ),
                            _c("b", [_vm._v("skilldoo-Klick-System")]),
                            _vm._v(
                              " ist der zu besetzende Job schnell in das\n\t\t\t\t\t\t\t\tSystem\n\t\t\t\t\t\t\t\teingetragen und skilldoo sucht automatisiert nach passenden BewerberInnen."
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "Question",
                        {
                          attrs: {
                            title: "Warum können BewerberInnen anonym bleiben?"
                          }
                        },
                        [
                          _c("p", [
                            _vm._v(
                              "Grundsätzlich können auch die BewerberInnen selbst entscheiden, ob sie anfangs anonym\n\t\t\t\t\t\t\t\tbleiben wollen. Wenn jemand beispielsweise aktiv in einer Position ist und nicht\n\t\t\t\t\t\t\t\tmöchte, dass seine KollegInnen von der Jobsuche erfahren, ist das ein Vorteil."
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "Question",
                        {
                          attrs: {
                            title:
                              "Wie spare ich mit skilldoo Zeit und bekomme bessere Qualität?"
                          }
                        },
                        [
                          _c("p", [
                            _vm._v(
                              "Nach der kurzen Eingabe eines Jobs mit dem "
                            ),
                            _c("b", [_vm._v("skilldoo-Klick-System")]),
                            _vm._v(
                              " ist die zu\n\t\t\t\t\t\t\t\tbesetzende Position bereits veröffentlicht. Dadurch müssen nicht mehr aufwendig\n\t\t\t\t\t\t\t\tJobanzeigen getextet und grafisch umgesetzt werden. In weiterer Folge sucht skilldoo\n\t\t\t\t\t\t\t\tautomatisiert nach den am besten passenden BewerberInnen. Somit müssen sich\n\t\t\t\t\t\t\t\tArbeitgeberInnen nicht mehr durch Stapel an Lebensläufen arbeiten. Schließlich kann\n\t\t\t\t\t\t\t\tmit den passenden BewerberInnen ganz einfach Kontakt über die Kontakt-Funktion\n\t\t\t\t\t\t\t\taufgenommen werden. skilldoo bietet auch die Möglichkeit, ein Ranking der\n\t\t\t\t\t\t\t\tBewerberInnen zu erstellen. Das schafft mehr Übersicht und somit wiederum mehr\n\t\t\t\t\t\t\t\tZeitersparnis. In Summe bietet skilldoo eine hohe Zeitersparnis mit gleichzeitigem\n\t\t\t\t\t\t\t\tQualitätsgewinn."
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "Question",
                        {
                          attrs: {
                            title:
                              "Welche Vorteile bietet die Job-Matching Plattform skilldoo gegenüber althergebrachten Job-Plattplattformen?"
                          }
                        },
                        [
                          _c("p", [
                            _vm._v(
                              "skilldoo bietet dir im Vergleich einige Vorteile. Du sparst Mühen und wertvolle Zeit,\n\t\t\t\t\t\t\t\tweil du kein Inserat anlegen musst, sondern mit dem skilldoo-klick-System rasch ein\n\t\t\t\t\t\t\t\tJobprofil erstellst. Denn sobald du deine Daten eingetragen hast, sucht skilldoo\n\t\t\t\t\t\t\t\tautomatisch nach den am besten passenden Personen für dich. Du erfährst die für\n\t\t\t\t\t\t\t\tdeinen Job wichtigsten Informationen, statt aus Lebensläufen Dinge zu erraten. Das\n\t\t\t\t\t\t\t\terledigt das Best-Match-System, das speziell für skilldoo entwickelt wurde. Das\n\t\t\t\t\t\t\t\tfunktioniert ungefähr so wie bei bekannten Dating-Plattformen. Die Anonymität ist\n\t\t\t\t\t\t\t\tebenso ein großer Vorteil. Dadurch kannst du auch suchen, wenn der Job noch besetzt\n\t\t\t\t\t\t\t\tist oder du kein großes Suchbudget hast oder du noch warten musst auf irgendwem im\n\t\t\t\t\t\t\t\tUnternehmen, der die Suche endlich startet – jetzt kannst du das in die Hand nehmen.\n\t\t\t\t\t\t\t\tDie eingebaute Kontakt-Funktion ermöglicht es dir, direkt mit den BewerberInnen in\n\t\t\t\t\t\t\t\tKontakt zu treten. Du musst also nicht warten, ob sich irgendwer mal von selbst\n\t\t\t\t\t\t\t\tbewirbt. Und zum Schluss noch ein Vorteil: trotz des tollen Angebots ist skilldoo\n\t\t\t\t\t\t\t\tsehr kostengünstig!"
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "Question",
                        { attrs: { title: "Was ist ein Best-Match?" } },
                        [
                          _c("p", [
                            _vm._v(
                              "skilldoo sucht für dich nach dem Best-Match. Das bedeutet, dass nach der\n\t\t\t\t\t\t\t\tbestmöglichen Übereinstimmung zwischen den Anforderungen des Arbeitgebers und den\n\t\t\t\t\t\t\t\tProfilen der BewerberInnen gesucht wird. Sobald eine hohe und signifikante\n\t\t\t\t\t\t\t\tÜbereinstimmung besteht, bringt skilldoo dich und die potentielle MitarbeiterIn in\n\t\t\t\t\t\t\t\tVerbindung. Dann könnt ihr direkt in Kontakt treten. Selbstverständlich bleibst du\n\t\t\t\t\t\t\t\tdabei so lange anonym, wie du es für richtig hältst. Unser Best-Match-System dient\n\t\t\t\t\t\t\t\talso dazu, dass du keine Zeit verlierst und gleichzeitig die wirklich passenden\n\t\t\t\t\t\t\t\tPersonen siehst. Denn bei althergebrachten Plattformen kannst Du nur warten auf\n\t\t\t\t\t\t\t\tBewerbungen oder musst dich durch Berge an Profilen wühlen - und du weißt oft gar\n\t\t\t\t\t\t\t\tnicht, ob überhaupt Interesse an deinem Job besteht, den du besetzen willst."
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "Question",
                        { attrs: { title: "Wer steckt hinter skilldoo?" } },
                        [
                          _c("p", [
                            _vm._v(
                              "skilldoo wurde von einem erfahrenen Team unter Leitung von Peter Fiala und Alexander\n\t\t\t\t\t\t\t\tSchlögl entwickelt."
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "Peter ist seit mehr als zwei Jahrzehnten als Unternehmer auf hochwertige\n\t\t\t\t\t\t\t\tStellenvermittlung bzw. Recruiting spezialisiert. Alex ist ein seit 20 Jahren\n\t\t\t\t\t\t\t\tgefragter Softwareentwickler und verantwortet die digitale Umsetzung in allen\n\t\t\t\t\t\t\t\tBereichen. Das Unternehmen ist in Österreich beheimatet."
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "Wir haben die Wünsche von BewerberInnen und ArbeitgeberInnen sowie jahrzehntelange\n\t\t\t\t\t\t\t\tErfahrung einfließen lassen, um mit geringem Zeitaufwand zu den bestmöglichen\n\t\t\t\t\t\t\t\tBewerberInnen zu gelangen. Skills und Wünsche werden bestmöglich berücksichtigt."
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("b-col", { staticClass: "mt-4 mt-md-0", attrs: { md: "4" } }, [
                _c(
                  "div",
                  { staticClass: "avatar-text-button text-center" },
                  [
                    _c("Avatar", { attrs: { avatar: _vm.avatar } }),
                    _vm._v(" "),
                    _c("div", { staticClass: "title" }, [
                      _vm._v("Noch kein Job-Profil?")
                    ]),
                    _vm._v(" "),
                    _c("Button", {
                      attrs: {
                        text: "Los geht's",
                        href: "/kunde/eintragung",
                        icon: "caret-right"
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }